"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Plus = function Plus() {
  return _react["default"].createElement("svg", {
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "plus-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "plus-title"
  }, "Add or Change Currency Icon"), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-160.000000, -958.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(122.000000, 680.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(38.000000, 278.000000)"
  }, _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    stroke: "#FFFFFF",
    cx: "20",
    cy: "20",
    r: "19.5"
  }), _react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "19",
    y: "11",
    width: "2",
    height: "18",
    rx: "1"
  }), _react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "11",
    y: "19",
    width: "18",
    height: "2",
    rx: "1"
  })))))));
};

var _default = Plus;
exports["default"] = _default;